module.exports = __webpack_public_path__ + "media/images/flags/my-05adc6befa4fb588ee6cdf98aff2338f.svg";